import React from 'react';
import { Link } from 'react-router-dom';
import SeleccionarEmpresa from '../../components/seleccionarEmpresa/SeleccionarEmpresa';

const NotasEmpresa = (props) => {

    const handleSeleccionarEmpresa = (e, id) => {
        e.preventDefault();
        props.history.push({ pathname: '/portal/Notas', state: { idEmpresa: id } });
    }

    return(
        <div>
            <SeleccionarEmpresa onClick={handleSeleccionarEmpresa} />
        </div>
    );
}

export default NotasEmpresa;